export default "__VITE_ASSET__gPBYEfgV__"